import { Mutation, MutationTree } from "vuex";
import {
  SettingsCardSections,
  SettingsMutations,
  SettingsState,
  SettingsTitle
} from "@/components/settings/types";
import { UserInfo } from "@/services/apiService/api.types";

export const mutations: MutationTree<SettingsState> &
  Record<SettingsMutations, Mutation<SettingsState>> = {
  [SettingsMutations.setSettingsPageTitle](
    state,
    settingsTitle?: SettingsTitle
  ) {
    state.settingsPageTitle.heading = settingsTitle?.heading
      ? settingsTitle.heading
      : "";
    state.settingsPageTitle.subHeading = settingsTitle?.subHeading
      ? settingsTitle.subHeading
      : "";
  },
  [SettingsMutations.setPinOverlay](state, pinOverlayStatus: boolean) {
    state.openPinOverlay = pinOverlayStatus;
  },
  [SettingsMutations.setEncodedPin](state, numericPin: string) {
    state.encodedPin = btoa(numericPin);
  },
  [SettingsMutations.setOpenRightSideMenu](
    state,
    rightMenuOverlayStatus: boolean
  ) {
    state.openRightSideMenu = rightMenuOverlayStatus;
  },
  [SettingsMutations.setActiveCardIndex](state, cardIndex?: number) {
    state.activeCardIndex = cardIndex;
  },
  [SettingsMutations.setActiveCardSection](
    state,
    cardSection?: SettingsCardSections
  ) {
    state.activeCardSection = cardSection;
  },
  [SettingsMutations.setRightSideMenuTitle](
    state,
    rightSideMenuTitle?: SettingsTitle
  ) {
    state.rightSideMenuTitle.heading = rightSideMenuTitle?.heading
      ? rightSideMenuTitle.heading
      : "";
    state.rightSideMenuTitle.subHeading = rightSideMenuTitle?.subHeading
      ? rightSideMenuTitle.subHeading
      : "";
  },
  [SettingsMutations.setUserToEdit](state, userInfo?: UserInfo) {
    state.userToEdit = userInfo ? userInfo : undefined;
  },
  [SettingsMutations.setConfirmModalStatus](state, status: boolean) {
    state.confirmModalStatus = status;
  },
  [SettingsMutations.setOpenConfirmModal](state, status: boolean) {
    state.openConfirmModal = status;
  },
  [SettingsMutations.setConfirmModalMsg](state, msg: string) {
    state.confirmModalMsg = msg;
  },
  [SettingsMutations.setChannelCardCurrPos](state, pos?: number) {
    state.channelCardCurrPos = pos;
  },
  [SettingsMutations.setChannelCardNewPos](state, pos?: number) {
    state.channelCardNewPos = pos;
  }
};
